import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonResetFilter: React.FC<MprcButtonProps> = ({ text, title, variant = "contained", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonResetFilter.text;
    const lTitle = title || theme.buttons.ButtonResetFilter.title;

    return (
        <MprcButton
            {...rest}
            variant={variant}
            title={lTitle}
            text={lText}
        />
    );
};
